import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/countryNationality';

const fetchCountryNationality = createAction('fetchCountryNationality');

function fetchCountryNationalitySuccess(state, action) {
  const { countryNationality } = action.payload;
  state.countryNationality = countryNationality;
  state.successFetching = true;
  state.errorFetching = false;
}

function fetchCountryNationalityError(state) {
  state.countryNationality = [];
  state.successFetching = false;
  state.errorFetching = true;
}

const countryNationalityReducer = createSlice({
  name: 'countryNationality',
  initialState,
  reducers: {
    fetchCountryNationalitySuccess,
    fetchCountryNationalityError,
  },
});

export const countryNationalityActions = {
  ...countryNationalityReducer.actions,
  fetchCountryNationality,
};

export default countryNationalityReducer.reducer;
